module.exports = __webpack_public_path__ + "static/media/right-round-gray.e84a2cfd.svg";